export default __webpack_public_path__ + "14fc618360accefd805bfb5d58a0a6e1.svg";